export default { 
    mounted() {
        console.log('language mixin');
    },
    computed: {
        language() {
            return this.$store.state.language;
         },
         transitionState() {
            return this.$store.state.transitionState;
         }
    },
    watch: {
        language(newVal) {
            this.appLanguage = newVal;
        },
        transitionState() {
            // this watches every time a page changes
            this.appLanguage = this.language;
        }
    },
    methods: {
        getTranslation(phrase) {
            if (this.appLanguage != '') {
                let found = this.appLanguage.find(function (obj) { return obj.slug === phrase; })
                return found ? found.title : '';
            }
        },
    },
    data() {
        return {
          appLanguage:''
        }
    },
}


// WEBPACK FOOTER //
// ./src/mixins/Language.js